import Papa from 'papaparse';
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';

const handleExport = ({
  rows,
  setBlob,
}) => e => {
  setBlob(null);
  const rowData = rows;
  // Generate CSV File to download
  const csv = Papa.unparse(rowData);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  setBlob(blob);
};

const ExportButton = ({
  reportName,
  rows,
}) => {
  const [blob, setBlob] = useState(null);
  const url = blob ? URL.createObjectURL(blob) : null;
  return (
    <Box>
       {blob && url ? <Button 
          href={url}
          size='small'
          color='success'
          variant='text'
          disabled={!blob || !url}
          download={
            blob ? `${reportName}_${Date.now()}.csv` : null
          }
        >
          <DownloadIcon sx={{mr: 1}} />
          Download CSV
        </Button>
        : <Button 
          size='small'
          color='primary'
          variant='text'
          disabled={!rows || rows.length === 0}
          onClick={handleExport({rows, setBlob})}
        >
          <DownloadIcon sx={{mr: 1}} />
          Export CSV
        </Button>
      }
    </Box>
  );
};

export default ExportButton;